import {
	FETCH_WALL_POST_LIKES_REQUEST,
	FETCH_WALL_POST_LIKES_SUCCESS,
	FETCH_WALL_POST_LIKES_FAILURE,
} from '../../constants';

const initialState = {
	likes: [],
	loading: false,
	error: null,
}

const addWallPostLikesReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_WALL_POST_LIKES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};

		case FETCH_WALL_POST_LIKES_SUCCESS:
			return {
				...state,
				loading: false,
				likes: action.payload,
			};

		case FETCH_WALL_POST_LIKES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
}

export default addWallPostLikesReducer;
